import { nextTick, unref } from 'vue';
import type { ComponentRef } from '@mts-fe/types';
import type { ComputedRef, Ref } from 'vue';
import { warn } from '@mts/utils';

export function useTableScrollTo(
  tableElRef: Ref<ComponentRef>,
  getDataSourceRef: ComputedRef<Recordable[]>,
  getRowKey: ComputedRef,
) {
  let bodyEl: HTMLElement | null;

  function findTargetRowToScroll(targetRowData: Recordable) {
    const top =
      (bodyEl?.querySelector(`[data-row-key="${targetRowData[getRowKey.value]}"]`) as HTMLElement)
        ?.offsetTop ?? 0;
    bodyEl?.scrollTo({ top, behavior: 'smooth' });
  }

  async function scrollTo(pos: string) {
    const table = unref(tableElRef);
    if (!table) return;

    const tableEl: Element = table.$el;
    if (!tableEl) return;

    if (!bodyEl) {
      bodyEl = tableEl.querySelector('.ant-table-body');
      if (!bodyEl) return;
    }

    await nextTick();
    const dataSource = unref(getDataSourceRef);
    if (!dataSource) return;

    // judge pos type
    if (pos === 'top') {
      findTargetRowToScroll(dataSource[0]);
    } else if (pos === 'bottom') {
      findTargetRowToScroll(dataSource[dataSource.length - 1]);
    } else {
      const targetRowData = dataSource.find((data) => data[getRowKey.value] === pos);
      if (targetRowData) {
        findTargetRowToScroll(targetRowData);
      } else {
        warn(`rowKey ${pos} doesn't exist`);
      }
    }
  }

  return { scrollTo };
}
